import { render, staticRenderFns } from "./IcoMinus.vue?vue&type=template&id=17909bf6"
import script from "./IcoMinus.vue?vue&type=script&lang=js"
export * from "./IcoMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports